/** Sidebar menü — tek kaynak; path değerleri URL ile eşleşir. */
export const NAV_SECTIONS = [
  {
    title: 'Ana Menü',
    items: [{ path: 'dashboard', icon: 'home', label: 'Dashboard' }],
  },
  {
    title: 'Raporlar',
    items: [
      { path: 'fatura', icon: 'document', label: 'Fatura' },
      { path: 'financial', icon: 'currency', label: 'Finansal İşlemler' },
      { path: 'affiliator', icon: 'target', label: 'Affiliator Raporu' },
      { path: 'ip-analysis', icon: 'search', label: 'IP Analizi' },
      { path: 'monthly-growth', icon: 'chart', label: 'Aylık Büyüme Raporu' },
      { path: 'cohort-retention', icon: 'users', label: 'Cohort / Retention' },
      { path: 'correction-raporu', icon: 'edit', label: 'Correction Raporu' },
    ],
  },
  {
    title: 'Oyun & GGR',
    items: [
      { path: 'casino-dashboard', icon: 'casino', label: 'Casino Dashboard' },
      { path: 'sportsbook', icon: 'gamepad', label: 'Sportsbook' },
      { path: 'free-spin', icon: 'spin', label: 'Free Spin' },
      { path: 'bonus-raporu', icon: 'spin', label: 'Bonus Raporu' },
      { path: 'discount-raporu', icon: 'tag', label: 'Discount Raporu' },
      { path: 'yatirim-cekim-raporu', icon: 'card', label: 'Yatırım Çekim Raporu' },
      { path: 'kasa', icon: 'currency', label: 'Kasa' },
      { path: 'cekim-operasyon', icon: 'alert', label: 'Çekim Operasyon' },
      { path: 'ozel-oran', icon: 'target', label: 'Özel Oran' },
      { path: 'ggr-oyuncu', icon: 'grid', label: 'GGR / Oyuncu' },
      { path: 'ggr-saglayici', icon: 'puzzle', label: 'GGR / Sağlayıcı' },
      { path: 'ggr-oyun', icon: 'target', label: 'GGR / Oyun' },
    ],
  },
  {
    title: 'Kullanıcı Takibi',
    items: [
      { path: 'uye-takip', icon: 'users', label: 'Üye Takip' },
      { path: 'dogum-gunleri', icon: 'party', label: 'Doğum Günleri' },
      { path: 'suistimal', icon: 'alert', label: 'Suistimal Zaman Çizelgesi' },
      { path: 'fraud-risk', icon: 'shield', label: 'Dolandırıcılık Riski' },
      { path: 'musteri-risk', icon: 'shield', label: 'Müşteri Risk Zekâsı' },
      { path: 'top-winners', icon: 'trophy', label: 'En İyi Yatırımcılar' },
      { path: 'top-losers', icon: 'alert', label: 'Artıdaki Üyeler' },
    ],
  },
  {
    title: 'Sistem',
    items: [
      { path: 'hesap', icon: 'settings', label: 'Hesabım' },
      { path: 'kullanicilar', icon: 'users', label: 'Kullanıcılar' },
      { path: 'roller', icon: 'shield', label: 'Roller' },
      { path: 'telegram', icon: 'telegram', label: 'Telegram' },
      { path: 'yapay-zeka', icon: 'chart', label: 'Rapor Analizi' },
      { path: 'upload', icon: 'upload', label: 'Rapor Yükle' },
      { path: 'geri-donenler', icon: 'refresh', label: 'Geri Dönenler' },
      { path: 'ftd-report', icon: 'party', label: 'FTD Raporu' },
    ],
  },
];

/** Geliştirme aşamasındaki sekmeler — API bağlantısı sonraya bırakıldı. */
export const EXTENSION_ROUTES = [];
